import type { Dictionary } from "../../../../../apps/d2c-web/utils/dictionaries/get-dictionary";
import { cn } from "../../utils/cn";
import { TextD2C } from "../text-d2c/text";
export interface PriceProps {
  price: string;
  strikePrice?: string;
  priceType?: "BUY" | "FROM";
  size?: "default" | "large";
  className?: string;
  dictionaryLayout?: Dictionary["layout"];
}

export function Price(props: Readonly<PriceProps>) {
  const priceVariant = props.size === "large" ? "p-large" : "h5";

  return (
    <div className={cn("flex items-baseline gap-2", props.className)}>
      {props.priceType === "FROM" && props.dictionaryLayout?.from}
      {props.strikePrice ? (
        <>
          <div className="font-brand [&>*]:font-bold">
            <TextD2C variant={priceVariant}>{props.price}</TextD2C>
          </div>
          <div>
            <TextD2C style="line-through" variant="p">
              {props.strikePrice}
            </TextD2C>
          </div>
        </>
      ) : (
        <div className="font-brand [&>*]:font-bold">
          <TextD2C variant={priceVariant}>{props.price}</TextD2C>
        </div>
      )}
    </div>
  );
}
